import { I18n } from "@assets/strings";
import React from "react";
import { useFollowees } from "@domain/user/hooks";
import { ProfileListModal } from "@ui/components/profile/profileListModal";

interface FollowingModalProps extends React.HTMLAttributes<HTMLDivElement> {
	profileId: string;
	close: () => void;
	count?: string;
}
export const FollowingModal: React.FC<FollowingModalProps> = ({ count = undefined, profileId, ...props }) => {
	const data = useFollowees(profileId);
	// "profile.followees.title" is not pluralized: count is only displayed, and may be a readable string like "1k"
	const displayedCount = (count ? count : (data.totalElements ?? 0)) as number;

	return (
		<ProfileListModal
			title={I18n.t("profile.followees.title", { count: displayedCount })}
			emptyMessage={I18n.t("profile.followees.empty")}
			data={data}
			{...props}
		/>
	);
};
